// Presentation only: no grouping, rounding, input parsing or mutation of API data.
// Existing languages keep their current digit style. Bengali count labels use the
// same digits as Bengali dates and amounts, even when Intl is unavailable.
const BENGALI_DIGITS = '০১২৩৪৫৬৭৮৯';

export function formatDisplayCount(count: number, language?: string): string {
  const text = String(count);
  if (language !== 'bn' || !Number.isSafeInteger(count) || count < 0) return text;
  return text.replace(/[0-9]/g, (digit) => BENGALI_DIGITS[Number(digit)]);
}
